import { useEffect, useState } from 'react';

export default function usePersistentState(key, defaultValue) {
  const [state, setState] = useState(() => {
    if (typeof window === 'undefined') return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    try {
      const stored = window.localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (typeof parsed === 'object' && parsed !== null) {
          if (typeof defaultValue === 'function') {
            return { ...defaultValue(), ...parsed };
          }
          return { ...defaultValue, ...parsed };
        }
        return parsed;
      }
    } catch (err) {
      console.warn('Persistent state load failed', err);
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      console.warn('Persistent state save failed', err);
    }
  }, [key, state]);

  return [state, setState];
}
